module.exports = __webpack_public_path__ + "static/media/thumb.6d793e46.png";